/* Hover is an enhancement: native details retains keyboard and touch controls. */
(() => {
  const fine = matchMedia('(hover: hover) and (pointer: fine)');
  const roots = new WeakSet();
  function mount(root = document) {
    root.querySelectorAll('.header__inline-menu header-menu > details, [data-gx-hover-menu]').forEach(details => {
      if (roots.has(details)) return;
      roots.add(details);
      const summary = details.querySelector(':scope > summary');
      let closeTimer;
      const peers = () => document.querySelectorAll('.header__inline-menu header-menu > details, [data-gx-hover-menu]');
      const set = open => {
        details.open = open;
        summary.setAttribute('aria-expanded', String(open));
      };
      details.addEventListener('pointerenter', event => {
        if (!fine.matches || innerWidth < 990 || event.pointerType === 'touch') return;
        clearTimeout(closeTimer);
        peers().forEach(other => {
          if (other !== details) {
            other.open = false;
            other.querySelector(':scope > summary')?.setAttribute('aria-expanded', 'false');
          }
        });
        set(true);
      });
      details.addEventListener('pointerleave', () => {
        if (!fine.matches || innerWidth < 990) return;
        closeTimer = setTimeout(() => {
          if (!details.contains(document.activeElement)) set(false);
        }, 220);
      });
      details.addEventListener('focusout', () => {
        setTimeout(() => {
          if (!details.contains(document.activeElement) && !details.matches(':hover')) set(false);
        }, 0);
      });
      details.addEventListener('toggle', () => {
        summary.setAttribute('aria-expanded', String(details.open));
        if (details.open) peers().forEach(other => {
          if (other !== details) {
            other.open = false;
            other.querySelector(':scope > summary')?.setAttribute('aria-expanded', 'false');
          }
        });
      });
      details.addEventListener('keydown', event => {
        if (event.key === 'Escape') {
          clearTimeout(closeTimer);
          set(false);
          summary.focus();
          event.stopPropagation();
        }
      });
    });
  }
  mount();
  document.addEventListener('shopify:section:load', event => mount(event.target));
  document.addEventListener('click', event => {
    document.querySelectorAll('[data-gx-hover-menu][open]').forEach(details => {
      if (!details.contains(event.target)) details.open = false;
    });
  });
})();
